<template>
	<div>
		 <sql-run></sql-run>
	</div>
</template>

<script>
	import SqlRun from '@/components/project/SqlRun.vue'
	 
	export default {
		components: {
			SqlRun, 
		} ,

		data() {
			return {
  
			}
		},

		created() {

		},
		computed: {

		},
		methods: {



		},

	}
</script>


<style lang="scss" scoped>
	//内容字体
	.about-t {
		height: auto;
		overflow: hidden;
		text-align: left;
		font-size: 18px;
		line-height: 60px;
	}
	
	//标题字体
	 h2.about-cs {
		padding-top: 10px;
		color: #2d8cf0;
		font-size: 24px;
		height: 50px;
		text-align: left;
		font-weight: bold;
	}
</style>
